module.exports = require('./dist/animate-components.min.js');



//////////////////
// WEBPACK FOOTER
// ./~/animate-components/main.js
// module id = 135
// module chunks = 35783957827783 165096251595434 255450519475302